import { Avatar, Box } from '@mui/material';

const DETAIL_FRAME_PADDING = 2;
const FRAMED_LOGO_RADIUS = '12px';

type PropsType = {
    url?: string | null;
    name: string;
    size: number;
    maxWidth?: number;
};

export default function Logotype({ url, name, size, maxWidth }: PropsType) {
    const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';
    const resolvedMaxWidth = maxWidth ?? Math.round(size * 2.2);

    if (url) {
        return (
            <Box
                sx={{
                    display: 'inline-block',
                    p: `${DETAIL_FRAME_PADDING}px`,
                    bgcolor: '#fff',
                    borderRadius: FRAMED_LOGO_RADIUS,
                    flexShrink: 0,
                    lineHeight: 0
                }}
            >
                <Box
                    component="img"
                    src={url}
                    alt={name}
                    sx={{
                        height: 'auto',
                        width: size,
                        maxWidth: resolvedMaxWidth,
                        objectFit: 'contain',
                        objectPosition: 'center',
                        display: 'block',
                        borderRadius: FRAMED_LOGO_RADIUS
                    }}
                />
            </Box>
        );
    }

    return (
        <Avatar
            sx={{
                width: size,
                height: size,
                bgcolor: 'primary.main',
                fontWeight: 600,
                fontSize: Math.round(size * 0.4)
            }}
        >
            {initial}
        </Avatar>
    );
}
